export default __webpack_public_path__ + "static/product-feature-date-monitoring-fa2bf7b79a32198984c616ba8ddeac8c.svg";